<template>
  <g>
      <text transform="matrix(1 0 0 1 710 710)" class="name">아두이노 우노{{number}}</text>
      <g>
      <path class="ardu-st0" d="M814.5,423.47c0-2.2-1.41-5.11-3.14-6.47l-15.21-11.98c-1.73-1.36-3.14-4.27-3.14-6.47V331 c0-2.2-0.74-5.64-1.63-7.65l-4.71-4.71c-2.01-0.9-5.45-1.63-7.65-1.63H254c-2.2,0-5.64,0.74-7.65,1.63l-4.71,4.71 c-0.9,2.01-1.63,5.45-1.63,7.65v339c0,2.2,0.74,5.64,1.63,7.65l4.71,4.71c2.01,0.9,5.45,1.63,7.65,1.63h525 c2.2,0,5.64-0.74,7.65-1.63l4.71-4.71c0.9-2.01,1.63-4.9,1.63-6.42c0-1.52,1.41-3.89,3.14-5.25L811.36,654 c1.73-1.36,3.14-4.27,3.14-6.47V423.47z"/>
      </g>
      <circle class="ardu-st1" cx="793.5" cy="436.5" r="13"/>
      <g>
          <circle class="st2" cx="772" cy="406" r="13"/>
          <circle class="st3" cx="772" cy="406" r="5.5"/>
      </g>
      <g>
          <circle class="st2" cx="391" cy="332" r="13"/>
          <circle class="st3" cx="391" cy="332" r="5.5"/>
      </g>
      <circle class="ardu-st1" cx="364.5" cy="332.5" r="13"/>
      <circle class="ardu-st1" cx="793.5" cy="632.5" r="13"/>
      <path class="st4" d="M787.5,342.61h-174c-1.1,0-2-0.9-2-2v-16c0-1.1,0.9-2,2-2h174c1.1,0,2,0.9,2,2v16 C789.5,341.72,788.6,342.61,787.5,342.61z"/>
      <line class="st5" x1="475.5" y1="386.5" x2="780.5" y2="386.5"/>
      <rect x="220.5" y="599.5" class="st6" width="118" height="64"/>
      <line class="st5" x1="779.5" y1="619.5" x2="660.5" y2="619.5"/>
      <line class="st5" x1="631.5" y1="619.5" x2="511.5" y2="619.5"/>
      <g>
          <circle class="st7" cx="267" cy="381" r="14.5"/>
          <circle class="st7" cx="267" cy="465" r="14.5"/>
          <rect x="184.5" y="382.5" class="st8" width="136" height="82"/>
      </g>
      <g style="transform: translate(-15px,-1px)">
          <g class="socket" :id="`${pincode}07`" @click="onClick(`${pincode}07`)">
              <rect x="646.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="642.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}06`" @click="onClick(`${pincode}06`)">
              <rect x="664.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="662.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}05`" @click="onClick(`${pincode}05`)">
              <rect x="682.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="680.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}04`" @click="onClick(`${pincode}04`)">
              <rect x="700.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="698.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}03`" @click="onClick(`${pincode}03`)" >
              <rect x="718.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="716.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}02`" @click="onClick(`${pincode}02`)" >
              <rect x="736.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="734.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}01`" @click="onClick(`${pincode}01`)" >
              <rect x="754.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="752.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}00`" @click="onClick(`${pincode}00`)">
              <rect x="772.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="770.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
      </g>
      <path class="st4" d="M601.5,342.61h-174c-1.1,0-2-0.9-2-2v-16c0-1.1,0.9-2,2-2h174c1.1,0,2,0.9,2,2v16 C603.5,341.72,602.6,342.61,601.5,342.61z"/>
      <!-- pin8 ~ pin aref -->
      <g style="transform:translate(-13px, -1px)">
          <g class="disable">
              <rect x="460" y="328.11" class="st9" width="11" height="11"/>
              <rect x="458" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}VG1`" @click="onClick(`${pincode}VG1`)">
              <rect x="478" y="328.11" class="st9" width="11" height="11"/>
              <rect x="476" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}13`" @click="onClick(`${pincode}13`)">
              <rect x="496.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="494.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}12`" @click="onClick(`${pincode}12`)">
              <rect x="514.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="512.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}11`" @click="onClick(`${pincode}11`)">
              <rect x="532.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="530.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}10`" @click="onClick(`${pincode}10`)">
              <rect x="550.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="548.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}09`" @click="onClick(`${pincode}09`)">
              <rect x="568.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="566.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}08`" @click="onClick(`${pincode}08`)">
              <rect x="586.5" y="328.11" class="st9" width="11" height="11"/>
              <rect x="584.5" y="326.11" class="pin-cover" width="12" height="12"/>
          </g>
      </g>
      <text transform="matrix(6.123234e-17 -1 1 6.123234e-17 443.2046 380.7285)">
          <tspan x="-6" y="14" class="st10 st11 st12">AREF</tspan>
          <tspan x="0" y="32" class="st10 st11 st12">GND</tspan>
          <tspan x="17.63" y="50" class="st10 st11 st12">13</tspan>
          <tspan x="17.63" y="68" class="st10 st11 st12">12</tspan>
          <tspan x="9.66" y="86" class="st10 st11 st12">~11</tspan>
          <tspan x="9.66" y="104" class="st10 st11 st12">~10</tspan>
          <tspan x="17.77" y="122" class="st10 st11 st12">~9</tspan>
          <tspan x="25.74" y="140" class="st10 st11 st12">8</tspan>
      </text>
      <text transform="matrix(6.123234e-17 -1 1 6.123234e-17 627.9238 354.7051)">
          <tspan x="0" y="14" class="st10 st11 st12">7</tspan>
          <tspan x="-7.97" y="32" class="st10 st11 st12">~6</tspan>
          <tspan x="-7.97" y="50" class="st10 st11 st12">~5</tspan>
          <tspan x="0" y="68" class="st10 st11 st12">4</tspan>
          <tspan x="-7.97" y="86" class="st10 st11 st12">~3</tspan>
          <tspan x="0" y="104" class="st10 st11 st12">2</tspan>
          <tspan x="-28.08" y="122" class="st10 st11 st13">TX</tspan>
          <tspan x="-14.48" y="122" class="st10 st11 st12">→1</tspan>
          <tspan x="-28.96" y="140" class="st10 st11 st13">RX</tspan>
          <tspan x="-14.48" y="140" class="st10 st11 st12">←0</tspan>
      </text>
      <path class="st4" d="M783.5,679.61H651c-1.1,0-2-0.9-2-2v-16c0-1.1,0.9-2,2-2h132.5c1.1,0,2,0.9,2,2v16 C785.5,678.72,784.6,679.61,783.5,679.61z"/>
      <g style="transform:translate(-10px, -1px)">
          <g class="socket" :id="`${pincode}A0`" @click="onClick(`${pincode}A0`)">
              <rect x="678.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="676.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}A1`" @click="onClick(`${pincode}A1`)">
              <rect x="696.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="694.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}A2`" @click="onClick(`${pincode}A2`)">
              <rect x="714.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="712.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}A3`" @click="onClick(`${pincode}A3`)">
              <rect x="732.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="730.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}A4`" @click="onClick(`${pincode}A4`)">
              <rect x="750.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="748.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}A5`" @click="onClick(`${pincode}A5`)">
              <rect x="768.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="766.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
      </g>
      <path class="st4" d="M637.5,679.61H505c-1.1,0-2-0.9-2-2v-16c0-1.1,0.9-2,2-2h132.5c1.1,0,2,0.9,2,2v16 C639.5,678.72,638.6,679.61,637.5,679.61z"/>
      <g style="transform: translate(-10px, -1px)">
          <g class="disable">
              <rect x="532.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="530.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}V3`" @click="onClick(`${pincode}V3`)">
              <rect x="550.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="548.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}V5`" @click="onClick(`${pincode}V5`)">
              <rect x="568.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="566.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}VG2`" @click="onClick(`${pincode}VG2`)">
              <rect x="586.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="584.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="socket" :id="`${pincode}VG3`" @click="onClick(`${pincode}VG3`)">
              <rect x="604.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="602.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
          <g class="disable">
              <rect x="622.5" y="665.11" class="st9" width="11" height="11"/>
              <rect x="620.5" y="663.11" class="pin-cover" width="12" height="12"/>
          </g>
      </g>
      <text transform="matrix(6.123234e-17 -1 1 6.123234e-17 669.069 656.5234)">
          <tspan x="0" y="10" class="st10 st14 st12">A0</tspan>
          <tspan x="0" y="28" class="st10 st14 st12">A1</tspan>
          <tspan x="0" y="46" class="st10 st14 st12">A2</tspan>
          <tspan x="0" y="64" class="st10 st14 st12">A3</tspan>
          <tspan x="0" y="82" class="st10 st14 st12">A4</tspan>
          <tspan x="0" y="100" class="st10 st14 st12">A5</tspan>
      </text>
      <text transform="matrix(6.123234e-17 -1 1 6.123234e-17 521.1007 657.1875)">
          <tspan x="0" y="10" class="st10 st14 st15">RESET</tspan>
          <tspan x="0" y="28" class="st10 st14 st15">3.3V</tspan>
          <tspan x="0" y="46" class="st10 st14 st15">5V</tspan>
          <tspan x="0" y="64" class="st10 st14 st15">GND</tspan>
          <tspan x="0" y="82" class="st10 st14 st15">GND</tspan>
          <tspan x="0" y="100" class="st10 st14 st15">Vin</tspan>
      </text>
      <g>
      <g>
      <path class="st16" d="M697,432h-62c-9.94,0-18-8.06-18-18s8.06-18,18-18h62c9.94,0,18,8.06,18,18S706.94,432,697,432z"/>
      </g>
      <g>
          <g>
              <path class="st10" d="M637.43,416.82v-14.84h1.67v14.65c0,6.09,2.78,7.99,5.95,7.99c3.24,0,6.03-1.89,6.03-7.99v-14.65h1.58 v14.84c0,7.19-3.63,9.31-7.6,9.31C641.07,426.13,637.43,424.01,637.43,416.82z"/>
              <path class="st10" d="M659.16,401.98h1.77l9.24,16.77l2.53,4.69h0.07c-0.06-2.29-0.21-4.58-0.21-6.88v-14.57h1.57v23.72h-1.76 l-9.24-16.77l-2.53-4.69h-0.07c0.06,2.31,0.21,4.46,0.21,6.75v14.71h-1.57V401.98z"/>
              <path class="st10" d="M679.38,413.75c0-7.53,3.69-12.21,8.86-12.21s8.86,4.68,8.86,12.21c0,7.56-3.69,12.37-8.86,12.37 S679.38,421.31,679.38,413.75z M695.36,413.75c0-6.59-2.87-10.7-7.12-10.7s-7.12,4.1-7.12,10.7c0,6.62,2.87,10.86,7.12,10.86 S695.36,420.38,695.36,413.75z"/>
          </g>
      </g>
      </g>
      <g>
          <g>
              <rect x="741" y="428.05" class="st17" width="4" height="5"/>
              <rect x="738" y="427.05" class="st18" width="3" height="7"/>
              <rect x="718" y="428.05" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1440 861.11)" class="st17" width="4" height="5"/>
              <rect x="722" y="427.05" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1447 861.11)" class="st18" width="3" height="7"/>
              <rect id="power-on" x="725.5" y="426.05" class="st19" width="12" height="9"/>
          </g>
      <text transform="matrix(1 0 0 1 748.5078 433.3235)" class="st10 st14 st20">ON</text>
      </g>
      <g>
          <g>
              <rect x="481.33" y="393.05" class="st17" width="4" height="5"/>
              <rect x="478.33" y="392.05" class="st18" width="3" height="7"/>
              <rect x="458.33" y="393.05" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 920.6667 791.11)" class="st17" width="4" height="5"/>
              <rect x="462.33" y="392.05" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 927.6667 791.11)" class="st18" width="3" height="7"/>
              <rect x="465.83" y="391.05" class="st19" width="12" height="11"/>
          </g>
          <text transform="matrix(1 0 0 1 449.6009 399.3235)" class="st10 st14 st20">L</text>
      </g>
      <g>
          <g>
              <rect x="481.33" y="429.05" class="st17" width="4" height="5"/>
              <rect x="478.33" y="428.05" class="st18" width="3" height="7"/>
              <rect x="458.33" y="429.05" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 920.6667 863.11)" class="st17" width="4" height="5"/>
              <rect x="462.33" y="428.05" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 927.6667 863.11)" class="st18" width="3" height="7"/>
              <rect x="465.83" y="427.05" class="st19" width="12" height="11"/>
          </g>
          <text transform="matrix(1 0 0 1 443.1556 435.3235)" class="st10 st14 st20">TX</text>
      </g>
      <g>
          <g>
              <rect x="481.33" y="444.05" class="st17" width="4" height="5"/>
              <rect x="478.33" y="443.05" class="st18" width="3" height="7"/>
              <rect x="458.33" y="444.05" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 920.6667 893.11)" class="st17" width="4" height="5"/>
              <rect x="462.33" y="443.05" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 927.6667 893.11)" class="st18" width="3" height="7"/>
              <rect x="465.83" y="442.05" class="st19" width="12" height="11"/>
          </g>
          <text transform="matrix(1 0 0 1 442.5423 450.3235)" class="st10 st14 st20">RX</text>
      </g>
      <g>
          <polygon class="st21" points="806,467.72 800.68,463.79 769.82,463.79 764.5,467.72 764.5,477.37 769.82,481.29 800.68,481.29 806,477.37 "/>
          <path class="st22" d="M780.31,477.17h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25c0.55,0,1,0.45,1,1v7.25 C781.31,476.72,780.86,477.17,780.31,477.17z"/>
          <path class="st23" d="M778.19,475.04h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3c0.55,0,1,0.45,1,1v3 C779.19,474.59,778.74,475.04,778.19,475.04z"/>
          <path class="st22" d="M797.31,477.17h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25c0.55,0,1,0.45,1,1v7.25 C798.31,476.72,797.86,477.17,797.31,477.17z"/>
          <path class="st23" d="M795.19,475.04h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3c0.55,0,1,0.45,1,1v3 C796.19,474.59,795.74,475.04,795.19,475.04z"/>
      </g>
      <g>
          <polygon class="st21" points="806,485.72 800.68,481.79 769.82,481.79 764.5,485.72 764.5,495.37 769.82,499.29 800.68,499.29 806,495.37 "/>
          <path class="st22" d="M780.31,495.17h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25c0.55,0,1,0.45,1,1v7.25 C781.31,494.72,780.86,495.17,780.31,495.17z"/>
          <path class="st23" d="M778.19,493.04h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3c0.55,0,1,0.45,1,1v3 C779.19,492.59,778.74,493.04,778.19,493.04z"/>
          <path class="st22" d="M797.31,495.17h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25c0.55,0,1,0.45,1,1v7.25 C798.31,494.72,797.86,495.17,797.31,495.17z"/>
          <path class="st23" d="M795.19,493.04h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3c0.55,0,1,0.45,1,1v3 C796.19,492.59,795.74,493.04,795.19,493.04z"/>
      </g>
      <g>
          <polygon class="st21" points="806,503.72 800.68,499.79 769.82,499.79 764.5,503.72 764.5,513.37 769.82,517.29 800.68,517.29 806,513.37"/>
          <path class="st22" d="M780.31,513.17h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25c0.55,0,1,0.45,1,1v7.25 C781.31,512.72,780.86,513.17,780.31,513.17z"/>
          <path class="st23" d="M778.19,511.04h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3c0.55,0,1,0.45,1,1v3 C779.19,510.59,778.74,511.04,778.19,511.04z"/>
          <path class="st22" d="M797.31,513.17h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25c0.55,0,1,0.45,1,1v7.25 C798.31,512.72,797.86,513.17,797.31,513.17z"/>
          <path class="st23" d="M795.19,511.04h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3c0.55,0,1,0.45,1,1v3 C796.19,510.59,795.74,511.04,795.19,511.04z"/>
      </g>
      <g>
          <polygon class="st21" points="367.42,346.79 363.5,352.11 363.5,382.97 367.42,388.29 377.08,388.29 381,382.97 381,352.11 377.08,346.79"/>
          <path class="st22" d="M376.88,372.48v7.25c0,0.55-0.45,1-1,1h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25 C376.43,371.48,376.88,371.93,376.88,372.48z"/>
          <path class="st23" d="M374.75,374.6v3c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3 C374.3,373.6,374.75,374.05,374.75,374.6z"/>
          <path class="st22" d="M376.88,355.48v7.25c0,0.55-0.45,1-1,1h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25 C376.43,354.48,376.88,354.93,376.88,355.48z"/>
          <path class="st23" d="M374.75,357.6v3c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3 C374.3,356.6,374.75,357.05,374.75,357.6z"/>
      </g>
      <g>
          <polygon class="st21" points="385.42,346.79 381.5,352.11 381.5,382.97 385.42,388.29 395.08,388.29 399,382.97 399,352.11 395.08,346.79"/>
          <path class="st22" d="M394.88,372.48v7.25c0,0.55-0.45,1-1,1h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25
              C394.43,371.48,394.88,371.93,394.88,372.48z"/>
          <path class="st23" d="M392.75,374.6v3c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3
              C392.3,373.6,392.75,374.05,392.75,374.6z"/>
          <path class="st22" d="M394.88,355.48v7.25c0,0.55-0.45,1-1,1h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25
              C394.43,354.48,394.88,354.93,394.88,355.48z"/>
          <path class="st23" d="M392.75,357.6v3c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3
              C392.3,356.6,392.75,357.05,392.75,357.6z"/>
      </g>
      <path class="st23" d="M410.75,374.6v3c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3
          C410.3,373.6,410.75,374.05,410.75,374.6z"/>
      <g>
          <polygon class="st21" points="403.42,346.79 399.5,352.11 399.5,382.97 403.42,388.29 413.08,388.29 417,382.97 417,352.11 413.08,346.79"/>
          <path class="st22" d="M412.88,372.48v7.25c0,0.55-0.45,1-1,1h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25
              C412.43,371.48,412.88,371.93,412.88,372.48z"/>
          <path class="st22" d="M412.88,355.48v7.25c0,0.55-0.45,1-1,1h-7.25c-0.55,0-1-0.45-1-1v-7.25c0-0.55,0.45-1,1-1h7.25
              C412.43,354.48,412.88,354.93,412.88,355.48z"/>
      </g>
      <path class="st23" d="M410.75,357.6v3c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1v-3c0-0.55,0.45-1,1-1h3
          C410.3,356.6,410.75,357.05,410.75,357.6z"/>
      <text transform="matrix(1 0 0 1 708.4375 631.0439)" class="st10 st14 st15">ANALOG IN</text>
      <text transform="matrix(1 0 0 1 626.6875 379.0439)">
          <tspan x="0" y="0" class="st10 st14 st15">DIGITAL  (PWM</tspan>
          <tspan x="82.83" y="0" class="st10 st24 st15">~</tspan>
          <tspan x="90.59" y="0" class="st10 st14 st15">)</tspan>
      </text>
      <text transform="matrix(1 0 0 1 690.8298 530.0439)" class="st10 st14 st25">RESET</text>
      <text transform="matrix(1 0 0 1 592.3174 631.0439)" class="st10 st14 st15">POWER</text>
      <g>
          <rect x="678" y="474.75" class="st26" width="52.46" height="44"/>
          <circle class="st27" cx="704.46" cy="496.75" r="12.5"/>
          <g>
              <rect x="662" y="477" class="st28" width="13" height="10"/>
              <rect x="670" y="479" class="st10" width="8" height="6"/>
              <rect x="667" y="477" class="st29" width="3" height="10"/>
          </g>
          <g>
              <rect x="733" y="477" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1479 964)" class="st28" width="13" height="10"/>
              <rect x="730" y="479" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1468 964)" class="st10" width="8" height="6"/>
              <rect x="738" y="477" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1479 964)" class="st29" width="3" height="10"/>
          </g>
          <g>
              <rect x="733" y="506" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1479 1022)" class="st28" width="13" height="10"/>
              <rect x="730" y="508" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1468 1022)" class="st10" width="8" height="6"/>
              <rect x="738" y="506" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1479 1022)" class="st29" width="3" height="10"/>
          </g>
          <g>
              <rect x="733" y="491.5" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1479 993)" class="st28" width="13" height="10"/>
              <rect x="730" y="493.5" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1468 993)" class="st30" width="8" height="6"/>
              <rect x="730" y="490" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 1463 993)" class="st10" width="3" height="13"/>
          </g>
          <g>
              <rect x="662" y="507" class="st28" width="13" height="10"/>
              <rect x="670" y="509" class="st10" width="8" height="6"/>
              <rect x="667" y="507" class="st29" width="3" height="10"/>
          </g>
      </g>
      <g>
          <path class="st31" d="M429.48,514.75h-66c-7.46,0-13.5-6.04-13.5-13.5l0,0c0-7.46,6.04-13.5,13.5-13.5h66
              c7.46,0,13.5,6.04,13.5,13.5l0,0C442.98,508.71,436.93,514.75,429.48,514.75z"/>
          <text transform="matrix(-1 0 0 -1 421.8389 497.1416)" class="st32 st24 st33">T 16000</text>
      </g>
      <g>
          <rect x="242.5" y="545.75" class="st34" width="46" height="39"/>
          <rect x="288.5" y="545.5" class="st6" width="32" height="44"/>
          <g>
              <rect x="324" y="545" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 661 1100)" class="st28" width="13" height="10"/>
              <rect x="321" y="547" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 650 1100)" class="st10" width="8" height="6"/>
              <rect x="329" y="545" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 661 1100)" class="st29" width="3" height="10"/>
          </g>
          <g>
              <rect x="324" y="561" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 661 1132)" class="st28" width="13" height="10"/>
              <rect x="321" y="563" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 650 1132)" class="st10" width="8" height="6"/>
              <rect x="329" y="561" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 661 1132)" class="st29" width="3" height="10"/>
          </g>
          <g>
              <rect x="324" y="578" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 661 1166)" class="st28" width="13" height="10"/>
              <rect x="321" y="580" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 650 1166)" class="st10" width="8" height="6"/>
              <rect x="329" y="578" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 661 1166)" class="st29" width="3" height="10"/>
          </g>
          <rect x="271" y="553.75" class="st35" width="17" height="23"/>
      </g>
      <g>
          <rect x="404.65" y="620" class="st36" width="11.36" height="7.52"/>
          <rect x="404.65" y="667.48" class="st36" width="11.36" height="7.52"/>
          <g>
              <path class="st37" d="M434,647.74c0-12.98-10.6-23.5-23.67-23.5c-13.07,0-23.67,10.52-23.67,23.5c0,1.61,0.16,3.18,0.47,4.7h46.38
                  C433.84,650.92,434,649.35,434,647.74z"/>
              <path class="st38" d="M387.14,652.44c2.19,10.73,11.74,18.8,23.19,18.8s21-8.08,23.19-18.8H387.14z"/>
          </g>
          <text transform="matrix(6.123234e-17 -0.9931 1 6.081219e-17 400.8418 650.1631)"><tspan x="0" y="0" class="st39 st14 st40">e</tspan><tspan x="7.07" y="0" class="st39 st14 st41">0</tspan><tspan x="0" y="11.36" class="st39 st14 st41">47</tspan><tspan x="0" y="22.72" class="st39 st14 st41">25V</tspan></text>
      </g>
      <g>
          <rect x="460.65" y="620" class="st36" width="11.36" height="7.52"/>
          <rect x="460.65" y="667.48" class="st36" width="11.36" height="7.52"/>
          <g>
              <path class="st37" d="M490,647.74c0-12.98-10.6-23.5-23.67-23.5c-13.07,0-23.67,10.52-23.67,23.5c0,1.61,0.16,3.18,0.47,4.7h46.38
                  C489.84,650.92,490,649.35,490,647.74z"/>
              <path class="st38" d="M443.14,652.44c2.19,10.73,11.74,18.8,23.19,18.8s21-8.08,23.19-18.8H443.14z"/>
          </g>
          <text transform="matrix(6.123234e-17 -0.9931 1 6.081219e-17 456.8418 650.1631)"><tspan x="0" y="0" class="st39 st14 st40">e</tspan><tspan x="7.07" y="0" class="st39 st14 st41">0</tspan><tspan x="0" y="11.36" class="st39 st14 st41">47</tspan><tspan x="0" y="22.72" class="st39 st14 st41">25V</tspan></text>
      </g>
      <g>
          <g>
              <g>
                  <path class="st10" d="M515.59,441.18h3.18l3.65,11.73h-2.82l-1.51-5.94c-0.3-1.17-0.65-2.55-0.94-3.78h-0.07
                      c-0.29,1.24-0.61,2.61-0.91,3.78l-1.53,5.94h-2.72L515.59,441.18z M514.36,448.05h5.61v2.07h-5.61V448.05z"/>
                  <path class="st10" d="M525.63,441.18h4.17c2.49,0,4.53,0.86,4.53,3.66c0,2.7-2.04,3.86-4.53,3.86h-1.51v4.22h-2.66V441.18z
                      M529.59,446.58c1.39,0,2.14-0.6,2.14-1.75c0-1.16-0.75-1.55-2.14-1.55h-1.3v3.3H529.59z M531.15,446.29l3.74,6.62h-2.97
                      l-2.61-4.92L531.15,446.29z"/>
                  <path class="st10" d="M538.25,441.18h3.24c3.4,0,5.64,1.78,5.64,5.81c0,4.04-2.24,5.92-5.49,5.92h-3.39V441.18z M541.34,450.77
                      c1.83,0,3.07-0.98,3.07-3.78c0-2.8-1.24-3.67-3.07-3.67h-0.44v7.46H541.34z"/>
                  <path class="st10" d="M550.73,448.4v-7.22h2.66v7.49c0,1.4,0.52,2.17,1.62,2.17c1.11,0,1.66-0.76,1.66-2.17v-7.49h2.56v7.22
                      c0,3.05-1.37,4.73-4.22,4.73C552.16,453.13,550.73,451.44,550.73,448.4z"/>
                  <path class="st10" d="M563.52,450.69h2.74v-7.28h-2.74v-2.23h8.14v2.23h-2.74v7.28h2.74v2.23h-8.14V450.69z"/>
                  <path class="st10" d="M575.97,441.18h2.72l2.47,5.83l1,2.58h0.06c-0.12-1.24-0.37-2.88-0.37-4.26v-4.15h2.53v11.73h-2.72
                      l-2.47-5.85l-1-2.57h-0.06c0.12,1.3,0.37,2.87,0.37,4.25v4.16h-2.53V441.18z"/>
                  <path class="st10" d="M588.06,446.99c0-3.92,1.92-6.03,4.72-6.03s4.72,2.11,4.72,6.03c0,4.01-1.92,6.14-4.72,6.14
                      S588.06,451.01,588.06,446.99z M594.78,446.99c0-2.44-0.77-3.74-2-3.74c-1.22,0-2,1.3-2,3.74c0,2.53,0.77,3.84,2,3.84
                      C594.01,450.83,594.78,449.52,594.78,446.99z"/>
              </g>
          </g>
          <g>
              <path class="st42" d="M604,414.5c0,9.62-8.93,16.5-22.19,16.5c-13.25,0-25.81-16.5-25.81-16.5s12.56-16.5,25.81-16.5
                  C595.07,398,604,404.88,604,414.5z"/>
              <path class="st42" d="M508,414.5c0-9.62,8.93-16.5,22.19-16.5c13.25,0,25.81,16.5,25.81,16.5S543.44,431,530.19,431
                  C516.93,431,508,424.12,508,414.5z"/>
          </g>
          <g>
              <g>
                  <g>
                      <path class="st10" d="M521.23,412.98h16.11v3.64h-16.11V412.98z"/>
                  </g>
              </g>
          </g>
          <g>
              <g>
                  <g>
                      <path class="st10" d="M580.4,416.61h-6.17v-3.64h6.17v-6.45h3.78v6.45h6.17v3.64h-6.17v6.45h-3.78V416.61z"/>
                  </g>
              </g>
          </g>
      </g>
      <g>
          <circle class="st2" cx="359" cy="664" r="13"/>
          <circle class="st3" cx="359" cy="664" r="5.5"/>
      </g>
      <path class="st43" d="M430.51,444.88l-23.14,18.14c-1.17,1.17-3.07,1.17-4.24,0l-23.14-18.14c-1.17-1.17-1.17-3.07,0-4.24
          l23.14-19.14c1.17-1.17,3.07-1.17,4.24,0l23.14,19.14C431.69,441.8,431.69,443.7,430.51,444.88z"/>
      <path class="st43" d="M429.51,445.88l-23.14,18.14c-1.17,1.17-3.07,1.17-4.24,0l-23.14-18.14c-1.17-1.17-1.17-3.07,0-4.24
          l23.14-19.14c1.17-1.17,3.07-1.17,4.24,0l23.14,19.14C430.69,442.8,430.69,444.7,429.51,445.88z"/>
      <g>
          <path class="st44" d="M430.12,445.88l-23.75,18.75c-1.17,1.17-3.07,1.17-4.24,0l-23.75-18.75c-1.17-1.17-1.17-3.07,0-4.24
              l23.75-19.75c1.17-1.17,3.07-1.17,4.24,0l23.75,19.75C431.3,442.8,431.3,444.7,430.12,445.88z"/>
      </g>
      <path class="st43" d="M659.48,568.79l-27.69,21.71c-1.4,1.4-3.67,1.4-5.08,0l-27.69-21.71c-1.4-1.4-1.4-3.67,0-5.08l27.69-22.91
          c1.4-1.4,3.67-1.4,5.08,0l27.69,22.91C660.88,565.11,660.88,567.39,659.48,568.79z"/>
      <g>
          <path class="st45" d="M660.21,568.79l-28.42,22.44c-1.4,1.4-3.67,1.4-5.08,0l-28.42-22.44c-1.4-1.4-1.4-3.67,0-5.08l28.42-23.64
              c1.4-1.4,3.67-1.4,5.08,0l28.42,23.64C661.61,565.11,661.61,567.39,660.21,568.79z"/>
      </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'ArduinoUNO',
  data () {
    return {
      on: false,
      timemax: null
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    blinking () {
      if (this.on) {
        this.timemax = new window.TimelineMax({ repeat: -1 })
        this.timemax.to(`#${this.data.id} #power-on`, 0.5, { css: { fill: '#D32F2F' } })
          .to(`#${this.data.id} #power-on`, 0.5, { css: { fill: '#EF9A9A' } })
      }
    },
    start () {
      this.on = true
      this.blinking()
    },
    off () {
      this.on = false
      this.timemax.kill()
      this.timemax = new window.TimelineMax({ repeat: 0 })
      this.timemax.to(`#${this.data.id} #power-on`, 0.5, { css: { fill: '#F3DFC7' } })
      this.timemax = null
    }
  }
}

</script>

<style lang="scss" scoped>
.pin-cover{
  display: none;
  stroke-width: 3px;
  stroke: black;
  fill: #ff6f61;
}
.disable:hover{
  cursor: not-allowed;
}
.ardu-st0{fill:#1D517A;}
.ardu-st1{fill:#F5EEEF;stroke:#CCCCCC;stroke-miterlimit:10;}
.st2{fill:#7A7A68;}
.st3{fill:#ACA7A5;stroke:#CCCCCC;stroke-miterlimit:10;}
.st4{fill:#3E3945;}
.st5{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}
.st6{fill:#34313A;}
.st7{fill:#BEB7B5;stroke:#CCCCCC;stroke-miterlimit:10;}
.st8{fill:#BEB7B5;}
.st9{stroke:#514E55;stroke-width:2;stroke-miterlimit:10;}
.st10{fill:#FFFFFF;}
.st11{font-family:'Calibri-Bold';}
.st12{font-size:16px;}
.st13{font-size:13px;}
.st14{font-family:'Calibri';}
.st15{font-size:12px;}
.st16{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:1.0088,4.0352;}
.st17{fill:#E0E3DD;}
.st18{fill:#83746F;}
.st19{fill:#F3DFC7;stroke:#F4C57A;stroke-miterlimit:10;}
.st20{font-size:11px;}
.st21{fill:#2B262F;stroke:#CCCCCC;stroke-miterlimit:10;}
.st22{fill:#4C4044;}
.st23{fill:#A39784;}
.st24{font-family:'MyriadPro-Regular';}
.st25{font-size:10px;}
.st26{fill:#494849;}
.st27{fill:#76493E;}
.st28{fill:#CEC4C1;}
.st29{fill:#F4C57A;}
.st30{fill:#423941;}
.st31{fill:#797069;stroke:#CCCCCC;stroke-miterlimit:10;}
.st32{fill:#CCCCCC;}
.st33{font-size:14px;}
.st34{fill:#908482;}
.st35{fill:#F4F1EF;}
.st36{fill:#D5CDC7;}
.st37{fill:#D5CDC7;stroke:#E6E6E6;stroke-width:2;stroke-miterlimit:10;}
.st38{fill:#433F45;stroke:#E6E6E6;stroke-width:2;stroke-miterlimit:10;}
.st39{fill:#4D4D4D;}
.st40{font-size:14.2px;}
.st41{font-size:11.36px;}
.st42{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}
.st43{fill:#2D2427;}
.st44{fill:none;stroke:#CCCCCC;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:1.001,2.0019;}
.st45{fill:none;stroke:#CCCCCC;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:1.0053,2.0105;}
.socket{
    &:hover{
    fill: #ff6f61;
    cursor: pointer;
    .pin-cover{
            display: block;
        }
    }
}
.selected{
    path.ardu-st0{
        stroke-width: 2px;
        stroke: #ff6f61;
    }
}
</style>
